import { Col, Row, Form, Input, InputNumber, Checkbox } from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { withAppContext } from "../../../store/contextStore";
import Advertisement from "../../../common/Advertisement";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
} from "react-google-places-autocomplete";
class PrivateDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // privateDetails: {
      sellerName: "",
      sellerPhone: "",
      sellerAddress: "",
      citySearch: [],
      city: "",
      addressState: "",
      zipCode: "",
      geoIdData: {},
      // }
      Addressempty: true,
      makePrivateAddress: false,
      adverCount: 0,
    };
  }

  componentDidMount() {
    this.setState({
      adverCount: 1,
    });
    const { sellerHomeDetails } = this.props;
    const address =
      sellerHomeDetails.privateDetails &&
      sellerHomeDetails.privateDetails.address &&
      sellerHomeDetails.privateDetails.address;

    this.setState({
      citySearch: address,
      city:
        sellerHomeDetails.privateDetails &&
        sellerHomeDetails.privateDetails.city,
      addressState:
        sellerHomeDetails.privateDetails &&
        sellerHomeDetails.privateDetails.state,
      zipCode:
        sellerHomeDetails.privateDetails &&
        sellerHomeDetails.privateDetails.postalCode,
      makePrivateAddress:
        sellerHomeDetails.privateDetails &&
        sellerHomeDetails.privateDetails.makePrivateAddress &&
        sellerHomeDetails.privateDetails.makePrivateAddress,
    });
  }
  hanldeCheck = (e) => {
    this.setState({ makePrivateAddress: e.target.checked });
  };

  handleSellereProfile = async (name, value) => {
    await this.setState({
      ...this.state,
      [name]: value,
    });
  };

  onFinish = (e) => {
    e["userId"] = this.props.context.state.user.userid;
    e["city"] = this.state.city;
    e["state"] = this.state.addressState;
    e["address"] = this.state.citySearch;
    e["postalCode"] = this.state.zipCode;
    e["makePrivateAddress"] = this.state.makePrivateAddress;
    this.props.handleForm(e, "PRIVATE_DETAILS");
  };

  handleSelect = (address) => {
    this.setState(
      {
        city: "",
        addressState: "",
        zipCode: "",
      },
      () => {
        setTimeout(() => {
          this.getFormattedAddress(address);
        }, 600);
      }
    );
  };

  getFormattedAddress = (address) => {
    const citySearch = [];
    citySearch.push(address.label);
    this.setState({
      citySearch,
    });
    let cityValue = "";
    let stateValue = "";
    let zipCodeValue = "";
    geocodeByAddress(address.label)
      .then((results) => {
        const geoIdData = results[0];
        this.setState({
          geoIdData,
        });
        let address = results[0].address_components;
        for (let i = 0; i < address.length; i++) {
          if (address[i].types[0] === "locality") {
            cityValue = address[i].long_name;
          }
          if (address[i].types[0] === "administrative_area_level_1") {
            stateValue = address[i].short_name;
          }
          if (address[i].types[0] === "postal_code") {
            zipCodeValue = address[i].long_name;
          }
        }
        this.setState({
          city: cityValue,
          addressState: stateValue,
          zipCode: zipCodeValue,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  render() {
    const { sellerPhone, citySearch, city, addressState, zipCode } = this.state;
    // const { sellerHomeDetails } = this.props.context.state;
    const { sellerHomeDetails } = this.props;

    return (
      <div>
        <Row>
          <Col
            xl={{ span: 24, offset: 0 }}
            lg={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            xs={{ span: 22, offset: 1 }}
            sm={{ span: 22, offset: 1 }}
          >
            <div className="privateD-title">Private Details</div>
            <div style={{ marginBottom: 20 }}>
              <span className="privateD-des">
                Other agents can't see this info but if you want to use John Doe
                or Unknown you can
              </span>
            </div>
          </Col>
          <Col
            xl={{ span: 16, offset: 0 }}
            lg={{ span: 16, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            xs={{ span: 22, offset: 1 }}
            sm={{ span: 22, offset: 1 }}
          >
            <Form
              initialValues={{ remember: true }}
              onFinish={this.onFinish}
              size="large"
              id="form"
            >
              <Row>
                <Col
                  xl={{ span: 11, offset: 0 }}
                  lg={{ span: 11, offset: 0 }}
                  md={{ span: 24, offset: 0 }}
                  xs={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                >
                  <div className="form-titles">
                    First Name (Only you will see this)
                  </div>
                  <Form.Item
                    name="firstName"
                    initialValue={
                      sellerHomeDetails &&
                      sellerHomeDetails.privateDetails.firstName
                    }
                  >
                    <Input
                      placeholder="First Name"
                      className="form-input"
                      // value={sellerName}
                    />
                  </Form.Item>
                  <div className="form-titles">
                    Email (only you will see this)
                  </div>
                  <Form.Item
                    name="email"
                    initialValue={
                      sellerHomeDetails &&
                      sellerHomeDetails.privateDetails.email
                    }
                  >
                    <Input placeholder="Email" className="form-input" />
                  </Form.Item>

                  <div className="form-titles">Address</div>
                  <Form.Item className="google-form-search-add-home">
                    <GooglePlacesAutocomplete
                      className="form-input"
                      apiKey={process.env.REACT_APP_MAPS_KEY}
                      autocompletionRequest={{
                        componentRestrictions: {
                          country: ["us"],
                        },
                      }}
                      selectProps={{
                        citySearch,
                        defaultInputValue: `${
                          sellerHomeDetails.privateDetails
                            ? sellerHomeDetails.privateDetails.address &&
                              sellerHomeDetails.privateDetails.address
                            : ""
                        }`,
                        placeholder: "Search Address...",
                        onChange: (address) => {
                          this.handleSelect(address);
                        },
                      }}
                    />
                    <Checkbox
                      onChange={this.hanldeCheck}
                      // defaultChecked={
                      //   sellerHomeDetails &&
                      //   sellerHomeDetails.privateDetails &&
                      //   sellerHomeDetails.privateDetails.makePrivateAddress &&
                      //   sellerHomeDetails.privateDetails.makePrivateAddress
                      // }
                      checked={this.state.makePrivateAddress}
                    >
                      Make private
                    </Checkbox>
                  </Form.Item>
                  <div
                    style={{
                      textAlign: "left",
                      fontSize: "15px",
                      fontWeight: " 600",
                      letterSpacing: "0px",
                      color: "#131419",
                      marginTop: "-5px",
                      marginBottom: "5px",
                    }}
                  >
                    City / Town
                  </div>
                  <Input className="form-input" value={city} />
                </Col>

                <Col
                  xl={{ span: 11, offset: 1 }}
                  lg={{ span: 11, offset: 1 }}
                  md={{ span: 24, offset: 0 }}
                  xs={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                >
                  <div className="form-titles">
                    Last Name (Only you will see this)
                  </div>
                  <Form.Item
                    name="lastName"
                    initialValue={
                      sellerHomeDetails &&
                      sellerHomeDetails.privateDetails.lastName
                    }
                  >
                    <Input
                      placeholder="Last Name"
                      className="form-input"
                      // value={sellerName}
                    />
                  </Form.Item>

                  <div className="form-titles">
                    Seller Phone # (Only you will see this)
                  </div>
                  <Form.Item
                    name="sellerPhone"
                    initialValue={
                      sellerHomeDetails &&
                      sellerHomeDetails.privateDetails.sellerPhone
                    }
                  >
                    <InputNumber
                      placeholder="Phone"
                      className="form-input-number"
                      value={sellerPhone}
                      formatter={(value) => {
                        const cleaned = `${value}`.replace(/\D/g, "");
                        const match = cleaned.match(
                          /^(1|)?(\d{3})(\d{3})(\d{4})$/
                        );
                        if (match) {
                          const intlCode = match[1] ? "+1 " : "";
                          return [
                            intlCode,
                            "(",
                            match[2],
                            ") ",
                            match[3],
                            "-",
                            match[4],
                          ].join("");
                        }
                        return null;
                      }}
                    />
                  </Form.Item>

                  <div className="form-titles">State</div>
                  <Input className="form-input" value={addressState} />

                  <div className="form-titles">Zip Code</div>
                  <Input
                    className="form-input"
                    value={zipCode}
                    style={{ marginTop: "12px" }}
                  />

                  <Form.Item
                    name="postalCode"
                    initialValue={
                      sellerHomeDetails &&
                      sellerHomeDetails.privateDetails.postalCode
                    }
                  ></Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col
            xl={{ span: 7, offset: 1 }}
            lg={{ span: 7, offset: 1 }}
            md={{ span: 24, offset: 0 }}
            xs={{ span: 22, offset: 1 }}
            sm={{ span: 22, offset: 1 }}
          >
            {this.state.adverCount === 1 && (
              <Advertisement
                otherAds={false}
                adType="Square"
                adWhereToShow="Homes"
                adLimit="1"
                zipCode=""
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
export default withAppContext(withRouter(PrivateDetails));
